import { render, staticRenderFns } from "./InlineFeatureRating.vue?vue&type=template&id=747b6974"
import script from "./InlineFeatureRating.vue?vue&type=script&lang=js"
export * from "./InlineFeatureRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports